import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';
import type { TradingPhotoCardType } from '../types/TradingPhotoCardType';

export const batchUpdateTradingPhotoCards = async (tradingPhotoCards: TradingPhotoCardType[]) => {
  const response = await fetch(`${baseUrl()}/api/v1/trading_photo_cards/batch_update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      trading_photo_cards: tradingPhotoCards.map((tradingPhotoCard) => ({
        trading_photo_card_id: tradingPhotoCard.tradingPhotoCardId,
        status: tradingPhotoCard.status,
        category: tradingPhotoCard.category
      }))
    })
  });
  return response.json();
};
